import React from 'react';

import BlockStyledEditor from '../../Framework/Components/Form/BlockStyledEditor';
import BrandInput from '../../Framework/Components/Form/BrandInput';
import DateTime from '../../Framework/Components/Form/DateTime';
import Form from '../../Framework/Components/Form/Form';
import IngredientInput from '../../Framework/Components/Form/IngredientInput';
import VariantListInput from '../../Framework/Components/Form/VariantListInput';
import TextInput from '../../Framework/Components/Form/TextInput';
import Toggle from '../../Framework/Components/Form/Toggle';
import Image from '../../Framework/Components/Image/Image';
import TextResource from '../../Framework/Components/TextResource';
import Grid, { GridLeft, GridRight } from '../../Framework/Layouts/Grid';
import ProductReviews from '../../Framework/Pages/Product/Reviews';
import EntityUrlText from './EntityUrlText';
import SponsoredUrl from './SponsoredUrl';
import EanCodesInput from '../../Framework/Components/Form/EanCodesInput';
import CategoryDropdown from '../../Framework/Components/Form/Dropdown/CategoryDropdown';
import routes from '../../Routes/routes';
import CategoryHierarchyGroup from '../Categories/CategoryHierarchyGroup';
import ConcernGroup from '../Categories/ConcernGroup';

const ProductForm = (props) => {
    return (
        <Form {...props}>
            <TextResource
                name="product"
                className="text-3xl mb-8"
                isParagraph
                {...props}
            />

            <Grid classNames="mb-16">
                <GridLeft>
                    <EntityUrlText path={routes.product} buttonText="Product" />
                    <DateTime name="published_at" readOnly />
                    <BrandInput name="brand" />
                    <TextInput name="name" />
                    <VariantListInput name="variants" />
                    <BlockStyledEditor name="description" fullFeatureSet />
                    <Image name="images" limit={10} isDetachable />
                    <TextInput name="video_url" />
                </GridLeft>
                <GridRight>
                    <Toggle name="is_active" />
                    <Toggle name="is_sponsored" />
                    <SponsoredUrl />
                    <Toggle name="is_manufactured" />
                    <Toggle name="is_18_plus" />
                    <EanCodesInput resource="products" name="eans" />
                    <CategoryHierarchyGroup />
                    <CategoryDropdown
                        name="secondary_categories"
                        requestName="secondaryCategories"
                        type="product"
                        isMultiple
                        requiredField="primary_category"
                        excludedFields={[
                            'primary_category',
                            'sub_category',
                            'sub_sub_category',
                        ]}
                    />
                    <CategoryDropdown name="skin_types" type="skintype" />
                    <ConcernGroup />
                    <IngredientInput
                        name="ingredients"
                        isOrderable
                        isReversable
                        allowNew
                        className="tidy-tokens"
                    />
                </GridRight>
            </Grid>

            <TextResource
                name="reviews"
                className="text-3xl mb-8"
                isParagraph
                {...props}
            />
            <ProductReviews {...props} />
        </Form>
    );
};

export default ProductForm;
